export default __webpack_public_path__ + "static/media/n8n.32862889.svg";